"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _reactHookForm = require("react-hook-form");

var _prospectingContacts = require("../../../../constants/prospectingContacts.schemas");

var _StyledTextField = require("./StyledTextField");

var _StyledFieldSkeleton = require("./StyledFieldSkeleton");

var EmailCell = function EmailCell(_ref) {
  var _field$value;

  var rowIndex = _ref.rowIndex,
      columnData = _ref.columnData,
      rowData = _ref.rowData;
  var name = "".concat(_prospectingContacts.ContactStepField.contacts, ".").concat(rowIndex, ".").concat(_prospectingContacts.ContactField.email);

  var _useController = (0, _reactHookForm.useController)({
    control: columnData === null || columnData === void 0 ? void 0 : columnData.control,
    name
  }),
      field = _useController.field,
      error = _useController.fieldState.error;

  return rowData !== null && rowData !== void 0 && rowData.id ? /*#__PURE__*/_react.default.createElement(_StyledTextField.StyledTextField, (0, _extends2.default)({
    fullWidth: true,
    variant: "outlined"
  }, field, {
    label: "Email",
    value: (_field$value = field.value) !== null && _field$value !== void 0 ? _field$value : '',
    error: !!(error !== null && error !== void 0 && error.message),
    helperText: error === null || error === void 0 ? void 0 : error.message,
    disabled: columnData === null || columnData === void 0 ? void 0 : columnData.isLoading
  })) : /*#__PURE__*/_react.default.createElement(_StyledFieldSkeleton.StyledFieldSkeleton, {
    variant: "rect",
    width: "100%",
    height: 48
  });
};

var _default = /*#__PURE__*/(0, _react.memo)(EmailCell);

exports.default = _default;